import get from 'lodash/get';
import merge from 'lodash/merge';
import { morphism } from 'morphism';

import { merchantResponseSchema } from '@hero/schemas';

import { api } from './api';
import { endpoints } from './endpoints';

export const convertAsset = formData =>
  api
    .post(endpoints.convertAsset(), formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      responseType: 'blob'
    })
    .then(res => {
      return res.data;
    });

export const createEntities = formData =>
  api.post(endpoints.getEntities(), formData).then(res => {
    return res?.data?.data;
  });

export const getAssetInfo = formData =>
  api
    .post(endpoints.getAssetInfo(), formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(res => {
      return res?.data?.data;
    });
export const getCharities = params =>
  api
    .get(endpoints.getEntities(), {
      params: merge(
        {
          filters: {
            listingType: 'public',
            type: 'charity'
          }
        },
        params
      )
    })
    .then(res => res.data.data);

export const getDigitalWrappers = params =>
  api
    .get(endpoints.getEntities(), {
      params: merge(
        {
          filters: {
            listingType: 'public',
            type: 'digitalWrapper'
          }
        },
        params
      )
    })
    .then(res => res.data.data);

export const getEntityDetail = params =>
  api.get(endpoints.getEntityDetail(params)).then(res => res.data.data);

export const getHomeTopCategories = params =>
  api
    .get(endpoints.getEntities(), {
      params: merge(
        {
          filters: {
            listingType: 'public',
            type: 'config',
            keys: ['merchant.homepage.chip-slider']
          }
        },
        params
      )
    })
    .then(res => res.data.data);

export const getMerchant = params =>
  api
    .get(endpoints.getMerchant(), {
      params
    })
    .then(res => morphism(merchantResponseSchema.merchant, get(res, 'data.data')));

export const getMerchants = params =>
  api
    .get(endpoints.getMerchants(), {
      params
    })
    .then(res => morphism(merchantResponseSchema.merchantList, get(res, 'data.data')));

export const getPublicEntities = params =>
  api
    .get(endpoints.getPublicEntities(), {
      params
    })
    .then(res => res.data.data);

export const submissionRecognitionOrders = (params, body) =>
  api.post(endpoints.submissionRecognitionOrders(params), body).then(res => res.data.data);

export const updateEntities = (params, formData) =>
  api.put(endpoints.getEntityDetail(params), formData).then(res => {
    return res?.data?.data;
  });
export const uploadAsset = formData =>
  api
    .post(endpoints.uploadAsset(), formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(res => {
      return res?.data?.data;
    });
